export default [
  {
    name: 'HSSDataEdit',
    path: '/hssdataedit',
    component: () => import('./HSSDataEdit')
  }
]
